var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetention(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#clip0_931_4300)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.286 0H7.5a3.571 3.571 0 0 1 3.571 3.571v1.786c0 .986.8 1.786 1.786 1.786h1.786a3.571 3.571 0 0 1 3.571 3.571v7.5c0 .987-.8 1.786-1.785 1.786H4.286c-.987 0-1.786-.8-1.786-1.786V1.786C2.5.799 3.3 0 4.286 0Zm3.928 15a.714.714 0 1 0-1.428 0v.714a.714.714 0 1 0 1.428 0V15Zm2.143-2.857c.395 0 .714.32.714.714v2.857a.714.714 0 1 1-1.428 0v-2.857c0-.394.32-.714.714-.714Zm3.572-1.429a.714.714 0 1 0-1.429 0v5a.714.714 0 1 0 1.429 0v-5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.571a4.98 4.98 0 0 0-1.218-3.27 9.302 9.302 0 0 1 6.631 6.631 4.98 4.98 0 0 0-3.27-1.218h-1.786a.357.357 0 0 1-.357-.357V3.571Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_4300"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetention);
export default __webpack_public_path__ + "static/media/retention.41b79b85509130ebd5524ab3de1f0d6a.svg";
export { ForwardRef as ReactComponent };